import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

export type Severities = 'success' | 'warn' | 'info' | 'error'

@Component({
  selector: 'app-spinner-loading-excel',
  templateUrl: './spinner-loading-excel.component.html',
  styleUrls: ['./spinner-loading-excel.component.css'],
  providers: [MessageService]
})
export class SpinnerLoadingExcelComponent {

  @Input('loading') loading = false

progress = 0;
loadingText = 'Inicializando...';
  constructor(
    private messageService: MessageService
  ) {}

  /**
   * @description Show message
   * @param title Title of the message
   * @param message Body message of the message
   */
  showMessage(title: string, message: string, severities: Severities) {
    this.messageService.add({
      severity: severities,
      summary: title,
      detail: message
    })
  }

}
